/**
 * Signup Form Schema
 *
 * Zod schema for the initial signup form (email collection).
 * Replaces ValidatorForm validation.
 */

import { z } from "zod";

/**
 * Signup Form Schema
 *
 * Validates:
 * - email: Required, valid email format
 */
export const signupSchema = z.object({
  email: z
    .string({ message: "Please enter a valid email Id" })
    .min(1, "Please enter a valid email Id")
    .email({ message: "Please enter a valid email Id" }),
});

/**
 * TypeScript type inferred from the schema
 */
export type SignupFormData = z.infer<typeof signupSchema>;
